import { createSlice, PayloadAction } from "@reduxjs/toolkit";

export interface OverlayDarkeningSliceState {
  /** Header drawer (account/support/deals/vendor order items, etc.) */
  menuOpen: boolean;
  /** Search field menu + dropdown (Algolia) */
  searchOpen: boolean;
  /** Derived: any source requests dim + scroll lock */
  isDarkened: boolean;
}

function recomputeIsDarkened(state: OverlayDarkeningSliceState): void {
  state.isDarkened = state.menuOpen || state.searchOpen;
}

const initialState: OverlayDarkeningSliceState = {
  menuOpen: false,
  searchOpen: false,
  isDarkened: false,
};

export const overlayDarkeningSlice = createSlice({
  name: "overlayDarkeningSlice",
  initialState,
  reducers: {
    setMenuOverlayDarkened: (state, action: PayloadAction<boolean>) => {
      state.menuOpen = action.payload;
      recomputeIsDarkened(state);
    },
    setSearchOverlayDarkened: (state, action: PayloadAction<boolean>) => {
      state.searchOpen = action.payload;
      recomputeIsDarkened(state);
    },
  },
});

export const { setMenuOverlayDarkened, setSearchOverlayDarkened } = overlayDarkeningSlice.actions;
export default overlayDarkeningSlice;
